document.addEventListener('DOMContentLoaded', () => {
  const splide = new Splide( '.splide',{
    type: 'loop',
    arrows: false,
    pagination: false,
    autoWidth: true,
    gap: 32,
    mediaQuery: 'min',
    autoScroll: {
      speed: -0.8,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    breakpoints: {
      768: {
        speed: -1,
        gap: 64,
      },
    },
  } ).mount( window.splide.Extensions );

  const messageSplide = new Splide( '.js-kv-message-slide',{
    type: 'loop',
    arrows: false,
    pagination: false,
    autoWidth: true,
    autoHeight: true,
    gap: 32,
    mediaQuery: 'min',
    autoScroll: {
      speed: 0.5,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    breakpoints: {
      768: {
        autoScroll: {
          speed: 0.8,
        },
      },
    },
  } ).mount( window.splide.Extensions );

  const modalSplide = new Splide( '.js-modal-splide',{
    type: 'fade',
    arrows: false,
    pagination: false,
    perPage: 1,
    width: '100%',
  } ).mount();

  const modalOpen = document.querySelectorAll( '.js-modal-open' );
  const modalNext = document.querySelectorAll( '.js-modal-next' );
  const modalPrev = document.querySelectorAll( '.js-modal-prev' );
  let modalIndex = 0;
  const maxIndex = modalSplide.length - 1;

  modalOpen.forEach( ( item ) => {

    item.addEventListener( 'click', () => {
    modalIndex = Number( item.getAttribute( 'data-modal-index' ) );
    modalSplide.go( modalIndex );

      modalNext.forEach( ( item ) => {
        item.classList.add( 'is-active' );
      } );

      modalPrev.forEach( ( item ) => {
        item.classList.add( 'is-active' );
      } );

      if ( modalIndex === maxIndex ) {
        modalNext.forEach( ( item ) => {
          item.classList.remove( 'is-active' );
        } );
      } else if ( modalIndex === 0 ) {
        modalPrev.forEach( ( item ) => {
          item.classList.remove( 'is-active' );
        } );
      }
    } );
  } );

  modalNext.forEach( ( item ) => {
    item.addEventListener( 'click', (e) => {
      modalSplide.go( '>' );
      modalIndex++;

      modalPrev.forEach( ( item ) => {
        item.classList.add( 'is-active' );
      } );

      if ( modalIndex === maxIndex ) {
        modalNext.forEach( ( item ) => {
          item.classList.remove( 'is-active' );
        } );
      } else {
        modalNext.forEach( ( item ) => {
          item.classList.add( 'is-active' );
        } );
      }
    } );
  } );

  modalPrev.forEach( ( item ) => {
    item.addEventListener( 'click', (e) => {
      modalSplide.go( '<' );
      modalIndex--;

      modalNext.forEach( ( item ) => {
        item.classList.add( 'is-active' );
      } );

      if ( modalIndex === 0 ) {
        modalPrev.forEach( ( item ) => {
          item.classList.remove( 'is-active' );
        } );
      } else {
        modalPrev.forEach( ( item ) => {
          item.classList.add( 'is-active' );
        } );
      }
    } );
  } );

  const voiceSplide = new Splide( '.js-voice-splide',{
    type: 'slide',
    arrows: true,
    pagination: false,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        fixedWidth: 420,
        padding: {
          right: 'calc( 126 / 1512 * 100vw )',
          left: 'calc( 126 / 1512 * 100vw )',
        },
      },
    },
  } ).mount();

  const numberElms = document.querySelectorAll( '.js-interview-number-splide' );
  console.log( numberElms );
  numberElms.forEach( ( item ) => {
    const messageSplide = new Splide( item,{
      type: 'loop',
      direction: 'ttb',
      width: '100%',
      height: '100%',
      autoHeight: true,
      arrows: false,
      pagination: false,
      gap: 16,
      mediaQuery: 'min',
      autoScroll: {
        speed: 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        768: {
          autoScroll: {
            speed: 0.5,
          },
        },
      },
    } ).mount( window.splide.Extensions );
  } );
  
});
